import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EdiRfidAuditDeleteDialog from './EdiRfidAuditDeleteDialog';

class EdiRfidAuditDelete extends Component {
  render() {
    return (
      <div>
        <EdiRfidAuditDeleteDialog
          closeDialog={this.props.closeDialog}
          openDialog={this.props.openDialog}
          row={this.props}
        />
      </div>
    );
  }
}

EdiRfidAuditDelete.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  openDialog: PropTypes.func.isRequired,
};

export default EdiRfidAuditDelete;
